import ApiService from './ApiService';
import queryString from 'query-string';

/**
 * Get available public coupons for a store
 * @param {string} storeId - Store ID
 * @param {number} platform - 0=Kiosk, 10=Website, 20=Mobile
 * @returns {Promise} API response
 */
export async function apiGetAvailableCoupons(storeId, platform = 10) {
  return ApiService.fetchData({
    url: `PublicCoupon/GetAvailable?${queryString.stringify(
      {
        storeId,
        platform,
      },
      {
        skipNull: true,
      }
    )}`,
    method: 'get',
  });
}

/**
 * Apply public coupon to basket
 * @param {Object} basketData - Basket data with discountcode
 * @returns {Promise} API response
 */
export async function apiApplyPublicCoupon(basketData) {
  return ApiService.fetchData({
    url: `PublicCoupon/ApplyToBasket`,
    method: 'post',
    data: basketData,
  });
}
